import { render, staticRenderFns } from "./sedan.vue?vue&type=template&id=22a25714&scoped=true"
import script from "./sedan.vue?vue&type=script&setup=true&lang=ts"
export * from "./sedan.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./sedan.vue?vue&type=style&index=0&id=22a25714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a25714",
  null
  
)

export default component.exports